/* The page works with no JavaScript: the chips and the rail links are links,
   and the order control has a submit button. This upgrades it — the select
   submits itself, the button it replaces is hidden by .is-scripted, and the
   rail can be folded away. Nothing here builds markup, so nothing is lost if
   it never runs.

   The toggle means two different things either side of 861px, because the rail
   does: on a desktop it is showing by default and the control hides it, on a
   phone it is hidden by default and the control opens it. One button, two
   state classes, so neither viewport inherits the other's idea of "open". */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width:861px)');
  var KEY = 'crf:collection:rail-hidden';

  document.querySelectorAll('.crf-coll').forEach(function (root) {
    root.classList.add('is-scripted');

    var sort = root.querySelector('.crf-sort');
    if (sort && sort.form) {
      sort.addEventListener('change', function () { sort.form.submit(); });
    }

    var toggle = root.querySelector('.crf-coll__toggle');
    if (!toggle) return;
    var text = toggle.querySelector('.crf-coll__toggle-text');
    var showLabel = toggle.getAttribute('data-show') || 'Show Filters';
    var hideLabel = toggle.getAttribute('data-hide') || 'Hide Filters';

    // Remembered per viewer, and only for the desktop meaning of the control.
    // A phone drawer that reopened itself on every page would be a bug, not a
    // preference.
    var hidden = false;
    try { hidden = localStorage.getItem(KEY) === '1'; } catch (e) { /* private mode */ }

    function paint() {
      var open;
      if (DESKTOP.matches) {
        root.classList.toggle('is-railless', hidden);
        open = !hidden;
      } else {
        open = root.classList.contains('is-railopen');
      }
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (text) text.textContent = open ? hideLabel : showLabel;
    }

    toggle.addEventListener('click', function () {
      if (DESKTOP.matches) {
        hidden = !hidden;
        try { localStorage.setItem(KEY, hidden ? '1' : '0'); } catch (e) { /* private mode */ }
      } else {
        root.classList.toggle('is-railopen');
      }
      paint();
    });

    DESKTOP.addEventListener('change', paint);
    paint();
  });
}());
